// src/controller.ts
import ControllerProvider from "@cartridge/controller";
import { InjectedConnector } from "@starknet-react/core";
var ControllerConnector = class extends InjectedConnector {
  constructor(options) {
    const controller = new ControllerProvider(options);
    super({
      options: {
        id: controller.id,
        name: controller.name
      }
    });
    this.controller = controller;
  }
  async disconnect() {
    this.controller.disconnect();
  }
  username() {
    return this.controller.username();
  }
  async delegateAccount() {
    return await this.controller.delegateAccount();
  }
};
export {
  ControllerConnector
};
//# sourceMappingURL=index.js.map